import { Component, OnInit } from '@angular/core';
import { Incomings } from '../../../entity';
import { PaymentsService, SettingsService } from '../../../service';
import Enums from '../../../utils/enums';
import { SelectItem } from 'primeng/api';
import { IRecords } from '../../../interfaces';

@Component({
    selector: 'app-incomings-table',
    templateUrl: './incomings-table.component.html'
})
export class IncomingsTableComponent implements OnInit {
    incomings: Incomings[];
    types: SelectItem[];
    selectedType: SelectItem;
    isLoading: boolean;
    records: IRecords;

    rowGroupMetadata: any;

    constructor(
        private paymentService: PaymentsService,
        private settingsService: SettingsService
    ) { }

    ngOnInit(): void {
        this.types = [
            { label: 'Astazi', value: Enums.eIncomingsType.Today },
            { label: 'Ultimele 7 zile', value: Enums.eIncomingsType.Last7Days },
            { label: 'Ultimele 30 zile', value: Enums.eIncomingsType.Last30Days },
            { label: 'Luna curenta', value: Enums.eIncomingsType.CurrentMonth },
            { label: 'Luna trecuta', value: Enums.eIncomingsType.LastMonth }
        ];

        this.records = {
            totalRecords: 0,
            totalRON: 0,
            totalEUR: 0,
            totalNETRON: 0,
            totalNETEUR: 0
        };

        this.selectedType = this.types[0];
        this.refresh(1);
    }

    refresh(typeId: number): void {
        this.incomings = [];
        this.isLoading = true;

        this.paymentService.getIncomings(typeId).subscribe(data => {
            const incomings: Incomings[] = [];
            const records: IRecords = {
                totalRecords: 0,
                totalRON: 0,
                totalEUR: 0,
                totalNETRON: 0,
                totalNETEUR: 0
            };

            data.forEach(item => {
                const incoming = new Incomings();
                incoming.fromObject(item);
                incoming.NetTotalAmount = incoming.TotalAmount - (0.101807 * incoming.TotalAmount);
                incoming.NetTotalAmount = (Math.round(incoming.NetTotalAmount * 100) / 100);

                records.totalRecords += incoming.Total;

                switch (incoming.CurrencyID) {
                    case Enums.eCurrencyType.RON:
                        records.totalRON += incoming.TotalAmount;
                        records.totalNETRON += incoming.NetTotalAmount;
                        break;
                    case Enums.eCurrencyType.EUR:
                        records.totalEUR += incoming.TotalAmount;
                        records.totalNETEUR += incoming.NetTotalAmount;
                        break;
                }

                incomings.push(incoming);
            });

            records.totalNETEUR = (Math.round(records.totalNETEUR * 100) / 100);
            records.totalNETRON = (Math.round(records.totalNETRON * 100) / 100);

            records.totalEUR = (Math.round(records.totalEUR * 100) / 100);
            records.totalRON = (Math.round(records.totalRON * 100) / 100);

            this.records = records;
            this.isLoading = false;
            this.incomings = incomings.sort((a, b) => (a.PaymentMethodTypeID < b.PaymentMethodTypeID) ? 1 : -1);
            this.updateRowGroupMetaData();
        }, (err) => {
            this.isLoading = false;
        });
    }

    updateRowGroupMetaData(): void {
        this.rowGroupMetadata = {};
        if (this.incomings) {
            for (let i = 0; i < this.incomings.length; i++) {
                const rowData = this.incomings[i];
                const zone = rowData.ZoneName;

                if (i === 0) {
                    this.rowGroupMetadata[zone] = { index: 0, size: 1 };
                } else {
                    const previousRowData = this.incomings[i - 1];
                    const previousRowGroup = previousRowData.ZoneName;
                    if (zone === previousRowGroup) {
                        this.rowGroupMetadata[zone].size++;
                    } else {
                        this.rowGroupMetadata[zone] = { index: i, size: 1 };
                    }
                }
            }
        }
    }

    onSort(): void {
        this.updateRowGroupMetaData();
    }

    getPaymentMethod(paymentMethodTypeID: number): string {
        switch (paymentMethodTypeID) {
            case Enums.ePaymentMethodType.Card:
                return 'Card';
            case Enums.ePaymentMethodType.SMS:
                return 'SMS';
        }
    }

    getCurrency(currencyId: number): string {
        return this.settingsService.CURRENCY_TYPES(currencyId);
    }

    onChange(event) {
        // console.log(event);
    }
}
